
import { ReactNode } from 'react';
import cx from 'classnames';

interface ViewProps {
    id?: string;
    className?: string;
    children: ReactNode;
}

const ContentView = ({ id, className = '', children }: ViewProps) => {
    return (
        <div id={id} className={cx('w-full', {
            'space-y-2': ! ['space-', 'space-y-'].some(c => className.split(' ').some(n => n.startsWith(c))),
            'px-4 sm:px-16': ! ['p-', 'px-'].some(c => className.split(' ').some(n => n.startsWith(c))),
            'max-w-screen-xl mx-auto': ! className.includes('max-w-'),
            [className]: Boolean(className)
        })}>
            {children}
        </div>
    );
};

export { ContentView };